export default function SvgArrowDown(props: React.SVGProps<SVGSVGElement>) {
    return (
        <svg {...props} viewBox="0 0 18 21" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M8.99133 18.3047L8.99133 0.459961" stroke="white" strokeWidth="2" strokeMiterlimit="10" />
            <path d="M16.9828 11.3284L8.99137 19.0001L0.999984 11.3284" stroke="white" strokeWidth="2" strokeMiterlimit="10" />
        </svg>
    );
}
